import { FrozenPill } from '../../frozen-pill/FrozenPill'
import { PausedPill } from '../../paused-pill/PausedPill'
import { Token } from '@/domain/types/Token'
import { ReserveStatus } from '@/features/sparklend/common/data/market-info/reserve-status'
import { InternalLinkDestination } from '@/routing/types'
import { ColorFilter } from '@/ui/atoms/color-filter/ColorFilter'
import { InternalLink } from '@/ui/atoms/link/Link'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { cn } from '@/ui/utils/style'

interface TokenWithLogoProps {
  token: Token
  reserveStatus: ReserveStatus
  chainId: number
  from: InternalLinkDestination
}

export function TokenWithLogo({ token, reserveStatus, chainId, from }: TokenWithLogoProps) {
  const isPaused = reserveStatus === 'paused'
  const isFrozen = reserveStatus === 'frozen'

  return (
    <InternalLink
      to="/markets/$chainId/$asset"
      params={{ asset: token.address, chainId }}
      state={{ from }}
      variant="decorator"
      className="flex flex-row items-center gap-2"
    >
      <div className="flex shrink-0">
        <ColorFilter variant={isPaused ? 'red' : 'none'}>
          <TokenIcon token={token} className="h-6 w-6" />
        </ColorFilter>
      </div>
      <div className={cn('typography-label-2 text-primary', isPaused && 'text-system-error-primary')}>
        {token.symbol}
      </div>
      {isFrozen && <FrozenPill />}
      {isPaused && <PausedPill />}
    </InternalLink>
  )
}
